import type { PromotionFilters } from "@/features/promotion";

// ponytail: in-memory only — a reload or deep link falls back to the unfiltered list; persist if ops asks.
let last: PromotionFilters = {};

export function rememberListSearch(search: PromotionFilters): void {
  last = search;
}

export function lastListSearch(): PromotionFilters {
  return last;
}
